import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import * as Table from 'reactabular-table';
import { Flex } from 'rebass';
import { bindActionCreators } from 'redux';
import * as sort from 'sortabular';
import { PvCaret } from 'styles/CustomComponents';
import * as resolve from 'table-resolver';
import { PvRadioButton } from '../form/PvRadioButton';
import {selectLessonEntryAction} from "../../ducks/workItem";
import { PvCourseBadge } from '../PvBadge';
import { LessonTypeIcon } from '../../util/IconUtil';


class SelectUndoneDataTable extends React.Component {
  constructor(props) {
    super(props);
    const getSortingColumns = () => this.state.sortingColumns || {};

    const toggleSelection = (lesson) => {

      this.props.selectLesson(lesson);
    };

    let selectedLesson = this.props.selectedLesson;

    const sortable = sort.sort({
      getSortingColumns,
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumn({
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      },
      strategy: sort.strategies.byProperty
    });

    const columns = [
      {
        property: 'selected',
        props: {
          style: {
            width: '2em'
          }
        },
        cell: {
          formatters: [
            (value, props) => {
              return (
                <PvRadioButton defaultChecked={!!selectedLesson && selectedLesson.lesson.entityId === props.rowData.lesson.entityId} onChange={() => {
                  toggleSelection(props.rowData);
                }} />
              );
            }
          ],
          transforms: [
          ]
        }
      },
      {
        property: "lesson.lessonType",
        header: {
          label: <Translate value='datatable.lesson_type' />,
        },
        props: {
          style: {
            width: '5em',
            textAlign: 'center'
          }
        },
        cell: {
          formatters: [
            (value) => <LessonTypeIcon type={value} />
          ]
        }
      },
      {
        property: 'lesson.description',
        header: {
          label: <Flex alignItems='center' justifyContent='space-between'><Translate
            value='datatable.undone_entry' /><PvCaret /></Flex>,
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty
            })
          ]
        }
      },
      {
        property: "course",
        header: {
          label: <Translate value='datatable.course' />,
        },
        props: {
          style: {
            width: '8em'
          }
        },
        cell: {
          formatters: [
            course => <PvCourseBadge course={course}/>
          ]
        }
      },
    ].filter((c) => c !== false);

    this.state = {
      // Default sorting
      sortingColumns: {
        'lessonDescription': {
          direction: 'asc',
          position: 0
        },
      },
      columns,
      rows: resolve.resolve(
        {
          columns,
          method: resolve.nested
        }
      )(this.props.rows || [])
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      rows: resolve.resolve(
        {
          columns: this.state.columns,
          method: resolve.nested
        }
      )(props.rows || [])
    });
  }

  render() {

    const {
      stylingRenderers,
    } = this.props;

    const {sortingColumns, columns, rows} = this.state;
    const finalRows =
      sort.sorter({
        columns,
        sortingColumns,
        sort: orderBy,
        strategy: sort.strategies.byProperty
      })(rows);

    return (
      <Table.Provider
        renderers={stylingRenderers}
        columns={columns}>
        <Table.Header />
        <Table.Body rows={finalRows} rowKey={({rowData}) => rowData.entityId} />
      </Table.Provider>
    );
  }
}

SelectUndoneDataTable.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  stylingRenderers: PropTypes.object,
  user: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    selectedLesson: state.workItem.lessonEntry.selectedEntry
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  selectLesson: (selectedLesson) => selectLessonEntryAction(selectedLesson)
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectUndoneDataTable);


// WEBPACK FOOTER //
// ./src/components/datatable/SelectUndoneDataTable.jsx